<script>
import Base from "@/components/RequestDetails/RequestCalls.vue";

export default {
  name: "CustomerServiceRequestCalls",
  extends: Base,
};
</script>

